var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.1894C18 9.5985 17.947 9.03032 17.8485 8.48486H10V11.7083H14.4848C14.2917 12.75 13.7045 13.6326 12.822 14.2235V16.3144H15.5152C17.0909 14.8637 18 12.7273 18 10.1894Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9997 18.333C12.2497 18.333 14.1361 17.5868 15.5149 16.3141L12.8217 14.2232C12.0755 14.7232 11.1209 15.0186 9.9997 15.0186C7.82925 15.0186 5.99213 13.5527 5.33683 11.583H2.55273V13.7421C3.92395 16.4656 6.74213 18.333 9.9997 18.333Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33696 11.5831C5.17029 11.0831 5.07559 10.549 5.07559 9.99975C5.07559 9.45051 5.17029 8.91641 5.33696 8.41641V6.25732H2.55287C1.98847 7.38232 1.6665 8.65505 1.6665 9.99975C1.6665 11.3444 1.98847 12.6172 2.55287 13.7422L5.33696 11.5831Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9997 4.9809C11.2232 4.9809 12.3217 5.40135 13.1853 6.22711L15.5755 3.83696C14.1323 2.49226 12.2459 1.6665 9.9997 1.6665C6.74213 1.6665 3.92395 3.53393 2.55273 6.25741L5.33683 8.4165C5.99213 6.44681 7.82925 4.9809 9.9997 4.9809Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.4c6c4426.svg";
export { ForwardRef as ReactComponent };